import { createAction, props } from '@ngrx/store';

export const toggleSearchBar = createAction('[Dashboard] Toggle search bar', props<{ collapsed: boolean }>());

export const searchParcelsByUpids = createAction('[Dashboard] Search parcels by upid', props<{ upids: string[]; centerToFirst?: boolean }>());
